// Who may delete a customer. Deleting is an admin-only, irreversible action;
// the BFF enforces the same rule server-side (customers.controller delete gate).
//
// Role hierarchy matches the app-wide one used in SettingsPage and the BFF
// RolesGuard (lowest → highest). "Admin only" therefore also allows owner,
// which sits above admin — consistent with every other admin gate in the app.
const ROLE_HIERARCHY = ['light_agent', 'agent', 'supervisor', 'admin', 'owner'];

export function canDeleteCustomer(role: string | undefined): boolean {
  if (!role) return false;
  return ROLE_HIERARCHY.indexOf(role) >= ROLE_HIERARCHY.indexOf('admin');
}

// Who may edit a customer. Editing is admin-only; the BFF enforces the same
// rule server-side (customers.controller update gate). Same hierarchy as above.
export function canEditCustomer(role: string | undefined): boolean {
  if (!role) return false;
  return ROLE_HIERARCHY.indexOf(role) >= ROLE_HIERARCHY.indexOf('admin');
}
